import { profile } from '../data/content';

export function Footer() {
  return (
    <footer className="site-footer">
      <span>{profile.nickname}</span>
    </footer>
  );
}
